// extracted by mini-css-extract-plugin
export var copyableField = "_md-4";
export var customerBadge = "_md-0";
export var customerInfoTitle = "_md-2";
export var details = "_md-1";
export var dropdownContainer = "_md-5";
export var dropdownImage = "_md-6";
export var editAssigneeForm = "_md-a";
export var editButton = "_md-3";
export var email = "_md-7";
export var hidden = "_md-d";
export var input = "_md-8";
export var saveButton = "_md-b";
export var shopifyIcon = "_md-c";
export var suggestionBadge = "_md-e";
export var suggestionText = "_md-f";
export var username = "_md-9";